(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-confirm-limits.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/set-deposit-confirm-limits.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  HighLimitNote
} = svs.accountservicesReact.gameLimitDepositsForm;
const {
  trackingAccept,
  trackingLimit,
  eventActions
} = svs.accountservicesReact.gameLimitDepositsForm.tracking;
const {
  setDepositLimitAsync
} = svs.accountservicesReact.gameLimitDepositsForm.service;
const SetDepositLimitsConfirm = _ref => {
  let {
    dayLimit,
    monthLimit,
    handleGoBack,
    weekLimit,
    onSaved
  } = _ref;
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const [isBackButtonDisabled, setIsBackButtonDisabled] = React.useState(false);
  const customerServicePhone = '0770 - 11 11 11';
  const showSaveDepositLimitsErrorDialog = () => {
    const text = "\n       <p>Ett fel uppstod i samband med hantering av ins\xE4ttningsgr\xE4nserna.</p>\n       <p>F\xF6rs\xF6k igen eller kontakta Kundservice ".concat(customerServicePhone, "</p>\n    ");
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      type: svs.ui.dialog.type.ERROR,
      title: 'Ett fel har uppstått',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text
      }],
      actions: [{
        title: 'Okej'
      }]
    });
    svs.ui.dialog.api.add(dialog);
  };
  const saveDepositLimitsAsync = async (limitTypesArray, depositBudgetsArray) => {
    const {
      error,
      data
    } = await setDepositLimitAsync(limitTypesArray, depositBudgetsArray);
    if (!error && data) {
      const {
        limits
      } = data;
      return {
        error: null,
        data: limits
      };
    }
    return {
      error,
      data
    };
  };
  const saveLimits = async () => {
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    const limitTypesArray = ['DAY', 'WEEK', 'MONTH'];
    const depositBudgetsArray = [
    svs.utils.format.CurrencyAsJupiterString(dayLimit),
    svs.utils.format.CurrencyAsJupiterString(weekLimit),
    svs.utils.format.CurrencyAsJupiterString(monthLimit)];
    const {
      error,
      data: savedLimits
    } = await saveDepositLimitsAsync(limitTypesArray, depositBudgetsArray);
    if (error) {
      showSaveDepositLimitsErrorDialog();
      setIsButtonDisabled(false);
    } else {
      trackingAccept(eventActions.CONFIRM);
      trackingLimit();
      setIsButtonDisabled(false);
      onSaved(savedLimits);
    }
  };
  const goBack = async () => {
    if (isBackButtonDisabled) {
      return;
    }
    setIsBackButtonDisabled(true);
    trackingAccept(eventActions.CANCEL);
    handleGoBack();
    setIsButtonDisabled(false);
  };
  return React.createElement("div", {
    className: "padding-bottom-1"
  }, React.createElement("div", null, React.createElement("p", {
    className: "padding-bottom-1 align-left"
  }, "Det h\xE4r \xE4r vad du som mest kan s\xE4tta in p\xE5 ditt spelkonto:"), React.createElement("p", {
    className: "align-left f-bold f-700"
  }, svs.utils.format.Currency(monthLimit), " ", React.createElement("abbr", {
    "aria-label": "kronor",
    title: "kronor"
  }, "kr"), " per m\xE5nad"), React.createElement("p", {
    className: "align-left f-bold f-700"
  }, svs.utils.format.Currency(weekLimit), " ", React.createElement("abbr", {
    "aria-label": "kronor",
    title: "kronor"
  }, "kr"), " per vecka"), React.createElement("p", {
    className: "align-left f-bold f-700 margin-bottom-2"
  }, svs.utils.format.Currency(dayLimit), " ", React.createElement("abbr", {
    "aria-label": "kronor",
    title: "kronor"
  }, "kr"), " per dag"), React.createElement(HighLimitNote, {
    dayLimit: dayLimit,
    monthLimit: monthLimit,
    weekLimit: weekLimit
  })), React.createElement(Button, {
    block: true,
    className: "margin-xs-bottom-1 margin-md-bottom-1",
    disabled: isButtonDisabled,
    focus: true,
    onClick: saveLimits
  }, "Spara ins\xE4ttningsgr\xE4nser"), React.createElement(Button, {
    block: true,
    disabled: isBackButtonDisabled,
    onClick: goBack,
    transparent: true
  }, "\xC4ndra ins\xE4ttningsgr\xE4nser"));
};
svs.accountservicesReact.gameLimitDepositsForm.SetDepositLimitsConfirm = SetDepositLimitsConfirm;

 })(window);